module.exports = __webpack_public_path__ + "static/media/sun.3cdcdf72.svg";